import React, { useEffect, useState } from "react";
import useSpeechToText from "react-hook-speech-to-text";
import { useStores } from "../../store";
import { MdOutlineMic, MdOutlineMicOff } from "react-icons/md";
import { Observer } from "mobx-react";

export default function MuteButton({ onClick, isMutedd }) {
  const { InterviewStore } = useStores();

  const [isMobileBrowser, setisMobileBrowser] = useState(true);

  // const [micState, setMicState] = useState(false);
  /* ----------- speech recognition section methods for mobile view ----------- */
  const {
    error,
    interimResult,
    isRecording,
    results,
    startSpeechToText,
    stopSpeechToText,
  } = useSpeechToText({
    continuous: true,
    useLegacyResults: false,
  });

  // useEffect(() => {
  //   if (window.innerWidth < 768) {
  //     setisMobileBrowser(true);
  //     console.log("mobile");
  //   } else {
  //     console.log("web");
  //     setisMobileBrowser(false);
  //   }
  // }, []);

  useEffect(() => {
    console.log("isRecording", isRecording);
    InterviewStore.setIsUserSpeaking(isRecording);

    if (!isRecording && !InterviewStore.forceStopMic && results.length > 0) {
      InterviewStore.setMicState(true);
      InterviewStore.setMicToggled(true);
      InterviewStore.setAutoMicOffStamp();
      InterviewStore.mergeTheTranscript(true);
      // InterviewStore.setSpeechResult([]);
      startSpeechToText(); // restart speech to text if it is stopped
    } else {
      InterviewStore.setMicState(isRecording);
      console.log("isRecording 🎉🎉🎉🎉", isRecording);
    }
  }, [isRecording]);

  const onClickLocal = () => {
    if (isRecording) {
      InterviewStore.setForceStopMic(true);
      InterviewStore.mergeTheTranscript(true);
      return stopSpeechToText();
    }
    InterviewStore.setForceStopMic(false);
    return startSpeechToText();
  };

  const toggleVoice = (state) => {
    InterviewStore.setForceStopMic(false);
    if (state) {
      return startSpeechToText();
    }
    return stopSpeechToText();
  };

  const removeRepeatedWords = (sentence) => {
    // Split the sentence into an array of words
    const words = sentence.split(/\s+/);

    // Create a new array to store unique words
    const uniqueWords = [];

    // Iterate through the words
    for (const word of words) {
      // Check if the word is not already in the uniqueWords array
      if (!uniqueWords.includes(word)) {
        // If not, add it to the uniqueWords array
        uniqueWords.push(word);
      }
    }

    // Join the uniqueWords array back into a sentence
    const result = uniqueWords.join(" ");

    return result;
  };
  /* ------------ web browser support method for speech recognition ----------- */

  useEffect(() => {
    console.log("results", results);

    if (isMobileBrowser) {
      InterviewStore.setSpeechResult(results);

      if (results.length === 0) return;
      InterviewStore.setIsUserSpeaking(true);

      let finalTranscript = results[results.length - 1];

      if (finalTranscript?.transcript === undefined) return;

      // InterviewStore.setTranscription( finalTranscript?.transcript);
    } else {
      // web compatibility transcription
      let filteredTranscript = [];
      results.forEach((result) => {
        if (result?.timestamp > InterviewStore.lastSubmitTimeStamp) {
          filteredTranscript.push(result?.transcript);
        }
      });
      console.log(filteredTranscript);
      let allTranscript = filteredTranscript.join(" ");
      console.log("💥💥💥💥💥💥 -> ", allTranscript);
      // InterviewStore.setTranscription(allTranscript);
      InterviewStore.setUserVoiceInput(allTranscript);
      InterviewStore.setTranscription("");
    }
  }, [results]);

  useEffect(() => {
    // if (!mobileView) return;
    if (isMobileBrowser) return;

    // web compatibility transcription
    console.log(interimResult);
    if (interimResult === undefined) return;

    InterviewStore.setTranscription(interimResult);
  }, [interimResult]);

  /* ---------- mobile browser support method for speech recognition ---------- */

  // useEffect(() => {
  //   if (results.length === 0) return;
  //   let allTrascript = results[results.length - 1]?.transcript;
  //   if (allTrascript === undefined) return;
  //   InterviewStore.setUserVoiceInput(allTrascript);
  // }, [results]);

  return (
    <Observer>
      {() => (
        <>
          <div className="flex flex-col items-center">
            <div
              className={`border ${
                InterviewStore.micState ? "border-primary" : "border-gray-300"
              } p-3 md:p-4 lg:p-4 rounded-lg cursor-pointer`}
              onClick={() => onClickLocal()}
            >
              {InterviewStore.micState ? (
                <MdOutlineMic className="text-primary text-lg md:text-2xl lg:text-3xl" />
              ) : (
                <MdOutlineMicOff className="text-gray-500 text-lg md:text-2xl lg:text-3xl" />
              )}
            </div>
            <span
              className="hidden"
              id="muteMic"
              onClick={() => toggleVoice(false)}
            ></span>
            <span
              className="hidden"
              id="unMuteMic"
              onClick={() => toggleVoice(true)}
            ></span>
            <span className="mt-2 text-sm opacity-30 hidden md:block lg:block">
              Mutee
            </span>
          </div>
        </>
      )}
    </Observer>
  );
}
